<template>
    <div id="representative-settings" class="disableShortcut">
        <a-tabs default-active-key="1" :tab-position="mode" scrollable>
            <a-tab-pane key="1">
                <span slot="tab" :title="$t('message.profile')">
                    {{
                        $t("message.profile").length > 20
                            ? $t("message.profile").substring(0, 20) + "..."
                            : $t("message.profile")
                    }}
                </span>
                <div class="containerKeyOne">
                    <label class="imgUpload">
                        <a-avatar
                            v-if="$_.get(user, 'gravatar') === null && gravatar === null"
                            :size="84"
                            icon="user"
                        />
                        <a-avatar v-else :size="84" :src="gravatar || $_.get(user, 'gravatar')" />
                        <input id="profile-avatar" class="d-none" type="file" @change="uploadFile" />
                        <div class="imgUploadOver">+</div>
                    </label>
                    <div>
                        <div class="emailAddress">{{ $t("message.email") }}</div>
                        <div class="emailAddress">{{ $_.get(user, "email") }}</div>
                    </div>
                    <md-field class="disableShortcut">
                        <label class="md-fieldLabel">{{ $t("message.username") }}</label>
                        <md-input v-model="user.name" class="disableShortcut mDinput"></md-input>
                    </md-field>
                    <a-button type="primary" @click="changeUserName">
                        {{ $t("message.updateUserName") }}
                    </a-button>
                </div>
            </a-tab-pane>
            <a-tab-pane key="2">
                <span slot="tab" :title="$t('message.changePassword')">
                    {{
                        $t("message.changePassword").length > 17
                            ? $t("message.changePassword").substring(0, 17) + "..."
                            : $t("message.changePassword")
                    }}
                </span>
                <md-field
                    :class="{
                        'md-invalid': errors.first($t('message.oldPassword')) != null,
                    }"
                    class="disableShortcut"
                >
                    <label>{{ $t("message.oldPassword", { num: "6" }) }}</label>
                    <md-input
                        :ref="$t('message.password')"
                        v-model="oldPassword"
                        v-validate="'required|min:6'"
                        :name="$t('message.oldPassword')"
                        :placeholder="$t('message.oldPassword', { num: '6' })"
                        autocomplete="off"
                        class="disableShortcut"
                        trim
                        type="password"
                    ></md-input>
                    <span class="md-error">{{ errors.first($t("message.oldPassword")) }}</span>
                </md-field>
                <md-field
                    :class="{
                        'md-invalid': errors.first($t('message.newPassword')) != null,
                    }"
                    class="disableShortcut"
                >
                    <label>{{ $t("message.newPassword", { num: "6" }) }}</label>
                    <md-input
                        :ref="$t('message.password')"
                        v-model="newPassword"
                        v-validate="'required|min:6'"
                        :name="$t('message.newPassword')"
                        :placeholder="$t('message.passwordAtLeast', { num: '6' })"
                        autocomplete="off"
                        class="disableShortcut"
                        trim
                        type="password"
                    ></md-input>
                    <span class="md-error">{{ errors.first($t("message.newPassword")) }}</span>
                </md-field>
                <md-field
                    :class="{
                        'md-invalid': errors.first($t('message.passwordRepeat')) != null,
                    }"
                    class="disableShortcut"
                >
                    <label>{{ $t("message.passwordRepeat") }}</label>
                    <md-input
                        v-model="passwordConfirmation"
                        v-validate="'confirmed:' + $t('message.password') + '|min:6'"
                        :name="$t('message.passwordRepeat')"
                        autocomplete="off"
                        class="disableShortcut"
                        type="password"
                    ></md-input>
                    <span class="md-error">{{ errors.first($t("message.passwordRepeat")) }}</span>
                </md-field>
                <a-button type="primary" @click="changePassword">
                    {{ $t("message.changePassword") }}
                </a-button>
            </a-tab-pane>
            <a-tab-pane key="3">
                <span slot="tab" :title="$t('message.soundSettings')" id="notificationSettingsTab">
                    {{
                        $t("message.soundSettings").length > 17
                            ? $t("message.soundSettings").substring(0, 17) + "..."
                            : $t("message.soundSettings")
                    }}
                </span>
                <div class="containerKeyThree">
                    <div class="sound-settings-container">
                        <div
                            v-for="(i, ii) in [
                                'newVisitor',
                                'newConversation',
                                'assignedChat',
                                'newMessage',
                                'teamChatTeam',
                                'teamChatDm',
                                'teamChatDepartment',
                                'teamChatGroup',
                                'newAnnouncement',
                                'newTicketSound',
                            ]"
                            class="sound-settings-element width-500"
                            :key="ii"
                        >
                            <div
                                class="sound-settings-title"
                                :content="vtippyMessages[ii]"
                                v-tippy="{
                                    placement: 'top',
                                    zIndex: 1001,
                                }"
                            >
                                {{ $t("message." + i) }}
                            </div>
                            <b-form-select
                                v-model="notificationSettings[ii].soundFile"
                                class="sound-settings-select"
                                @change="playPreviewSound(notificationSettings[ii])"
                                v-tippy="{
                                    placement: 'top',
                                    zIndex: 1001,
                                }"
                                :content="$t('message.vtippySelectnotification')"
                            >
                                <b-form-select-option v-for="s in soundFiles" :key="s" :value="s"
                                    >{{ s }}
                                </b-form-select-option>
                            </b-form-select>
                            <input
                                :id="i"
                                v-model="notificationSettings[ii].audioLevel"
                                max="100"
                                min="0"
                                :name="i"
                                step="10"
                                type="range"
                                @change="playPreviewSound(notificationSettings[ii])"
                                v-tippy="{
                                    placement: 'top',
                                    zIndex: 1001,
                                }"
                                :content="$t('message.vtippyVoiceLevel')"
                            />
                            <label :for="i">{{ notificationSettings[ii].audioLevel }}%</label>
                            <md-button
                                class="md-icon-button md-primary play-sound-button"
                                @click="playPreviewSound(notificationSettings[ii])"
                                v-tippy="{
                                    placement: 'top',
                                    zIndex: 1001,
                                }"
                                :content="$t('message.vtippyStartVoice')"
                            >
                                <md-icon>play_circle</md-icon>
                            </md-button>

                            <md-button
                                class="md-icon-button md-primary play-sound-button"
                                @click="notificationSettings[ii].infinitePlay = !notificationSettings[ii].infinitePlay"
                                v-if="notificationSettings[ii].type === 'new_chat'"
                                v-tippy="{
                                    placement: 'top',
                                    zIndex: 1001,
                                }"
                                :content="$t('message.vtippyInfiniteNotification')"
                            >
                                <md-icon :style="{ color: !notificationSettings[ii].infinitePlay ? 'red' : 'green' }"
                                    >all_inclusive
                                </md-icon>
                            </md-button>
                        </div>
                    </div>
                    <div class="desktop-notifications">
                        <div class="desktop-notifications-header">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 22C13.1 22 14 21.1 14 20H10C10 21.1 10.9 22 12 22ZM18 16V11C18 7.93 16.37 5.36 13.5 4.68V4C13.5 3.17 12.83 2.5 12 2.5C11.17 2.5 10.5 3.17 10.5 4V4.68C7.64 5.36 6 7.92 6 11V16L4 18V19H20V18L18 16Z" fill="#5d5b8d"/>
                            </svg>
                            <h3 class="desktop-notifications-title">
                                {{ $t("message.desktopNotifications") }}
                            </h3>
                        </div>
                        <div class="desktop-notifications-switches">
                            <div
                                v-for="(i, ii) in [
                                    'newVisitor',
                                    'newConversation',
                                    'chatAssignedToUser',
                                    'newMessage',
                                    'newAnnouncement',
                                    'newTicketSound',
                                ]"
                                :key="ii"
                                class="notification-card"
                            >
                                <div class="notification-content">
                                    <div class="notification-icon">
                                        <svg v-if="i === 'newVisitor'" width="20" height="20" viewBox="0 0 24 24" fill="none">
                                            <path d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z" fill="#1890ff"/>
                                        </svg>
                                        <svg v-else-if="i === 'newConversation'" width="20" height="20" viewBox="0 0 24 24" fill="none">
                                            <path d="M20 2H4C2.9 2 2.01 2.9 2.01 4L2 22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM18 14H6V12H18V14ZM18 11H6V9H18V11ZM18 8H6V6H18V8Z" fill="#52c41a"/>
                                        </svg>
                                        <svg v-else-if="i === 'chatAssignedToUser'" width="20" height="20" viewBox="0 0 24 24" fill="none">
                                            <path d="M9 11.75C6.66 11.75 2 12.92 2 15.25V17H16V15.25C16 12.92 11.34 11.75 9 11.75ZM4.34 15C5.18 14.42 7.21 13.75 9 13.75C10.79 13.75 12.82 14.42 13.66 15H4.34ZM9 10C10.93 10 12.5 8.43 12.5 6.5C12.5 4.57 10.93 3 9 3C7.07 3 5.5 4.57 5.5 6.5C5.5 8.43 7.07 10 9 10ZM9 5C9.83 5 10.5 5.67 10.5 6.5C10.5 7.33 9.83 8 9 8C8.17 8 7.5 7.33 7.5 6.5C7.5 5.67 8.17 5 9 5ZM16.04 13.81C17.2 14.65 18 15.77 18 17H22V15.25C22 13.23 18.5 12.31 16.04 13.81ZM15 10C16.93 10 18.5 8.43 18.5 6.5C18.5 4.57 16.93 3 15 3C14.46 3 13.96 3.13 13.5 3.35C14.13 4.24 14.5 5.33 14.5 6.5C14.5 7.67 14.13 8.76 13.5 9.65C13.96 9.87 14.46 10 15 10Z" fill="#faad14"/>
                                        </svg>
                                        <svg v-else-if="i === 'newMessage'" width="20" height="20" viewBox="0 0 24 24" fill="none">
                                            <path d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H6L4 18V4H20V16Z" fill="#722ed1"/>
                                        </svg>
                                        <svg v-else-if="i === 'newAnnouncement'" width="20" height="20" viewBox="0 0 24 24" fill="none">
                                            <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z" fill="#eb2f96"/>
                                        </svg>
                                        <svg v-else width="20" height="20" viewBox="0 0 24 24" fill="none">
                                            <path d="M14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM16 18H8V16H16V18ZM16 14H8V12H16V14ZM13 9V3.5L18.5 9H13Z" fill="#13c2c2"/>
                                        </svg>
                                    </div>
                                    <span class="notification-label">{{ $t("message." + i) }}</span>
                                </div>
                                <md-switch v-model="notificationSettings[ii].desktopNotification" class="md-primary notification-switch" />
                            </div>
                        </div>
                    </div>
                    <div class="notification-warning">
                        <img
                            alt="warning"
                            class="notification-warning-img"
                            src="https://static.supsis.live/secure.png"
                        />
                        <p class="notification-warning-text">
                            {{ $t("message.problemsSound") }}
                        </p>
                    </div>
                </div>
            </a-tab-pane>
            <a-tab-pane key="4">
                <span slot="tab" :title="$t('message.languageSettings')">
                    {{
                        $t("message.languageSettings").length > 17
                            ? $t("message.languageSettings").substring(0, 17) + "..."
                            : $t("message.languageSettings")
                    }}
                </span>
                <div class="containerKeyFour">
                    <label class="key-four-label">{{ $t("message.languageSettings") }}:</label>
                    <select v-model="lang" class="keyfour-select">
                        <option v-for="lang in languages" :key="lang.code" :value="lang.code">{{ lang.originalName }}</option>
                    </select>
                </div>
            </a-tab-pane>
        </a-tabs>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import { sendSocketMessage } from "../utils/socketStream";
import * as _ from "lodash";
import log2 from "../utils/log2";
import { uploadAsset } from "../api/assetUpload";
import axios from "axios";
import languages from "../language/languages.json";
import { generateUUID } from "../utils/session";

const log = log2("RepresentativeSettings");
export default {
    props: {
        isTargetNotification: {
            type: Boolean,
            default: false,
        },
    },
    name: "RepresentativeSettings",
    data() {
        return {
            mode: "left",
            languages,
            gravatar: null,
            isFirstOpening: true,
            oldPassword: "",
            newPassword: "",
            passwordConfirmation: "",
            volume: 0,
            notificationSettings: [
                {
                    type: "new_visitor",
                    soundFile: "new-conversation-default",
                    audioLevel: 100,
                    desktopNotification: false,
                    infinitePlay: false,
                },
                {
                    type: "new_chat",
                    soundFile: "exquisite",
                    audioLevel: 100,
                    desktopNotification: false,
                    infinitePlay: false,
                },
                {
                    type: "new_conversation",
                    soundFile: "exquisite",
                    audioLevel: 100,
                    desktopNotification: false,
                    infinitePlay: false,
                },

                {
                    type: "new_message",
                    soundFile: "exquisite",
                    audioLevel: 100,
                    desktopNotification: false,
                    infinitePlay: false,
                },
                {
                    type: "team_chat_team",
                    soundFile: "exquisite",
                    audioLevel: 100,
                    desktopNotification: false,
                    infinitePlay: false,
                },
                {
                    type: "team_chat_dm",
                    soundFile: "exquisite",
                    audioLevel: 100,
                    desktopNotification: false,
                    infinitePlay: false,
                },
                {
                    type: "team_chat_department",
                    soundFile: "exquisite",
                    audioLevel: 100,
                    desktopNotification: false,
                    infinitePlay: false,
                },
                {
                    type: "team_chat_group",
                    soundFile: "exquisite",
                    audioLevel: 100,
                    desktopNotification: false,
                    infinitePlay: false,
                },
                {
                    type: "new_announcement",
                    soundFile: "exquisite",
                    audioLevel: 100,
                    desktopNotification: false,
                    infinitePlay: false,
                },
                {
                    type: "ticket_sound",
                    soundFile: "exquisite",
                    audioLevel: 100,
                    desktopNotification: false,
                    infinitePlay: false,
                },
            ],
            soundFiles: [
                "done-for-you",
                "exquisite",
                "for-sure",
                "hey-champ",
                "juntos",
                "just-saying",
                "oringz",
                "percussion-sound",
                "plucky",
                "sharp",
                "swiftly",
                "take-this",
                "pm-default",
                "new-message-default",
                "new-conversation-default",
                "presto",
                "telefono-viejo",
                "new-chat-male-",
                "new-chat-female-",
                "new-visitor-male-",
                "new-visitor-female-",
            ],
            vtippyMessages: [
                this.$t("message.vtippyNewVisitorNotification"),
                this.$t("message.vtippyNewChatNotification"),
                this.$t("message.vtippyNewConversationNotification"),
                this.$t("message.vtippyNewMessageNotification"),
                this.$t("message.vtippyPrivateMessageNotification"),
                this.$t("message.vtippyTicketNotification"),
                this.$t("message.vtippyDepartmentNotification"),
                this.$t("message.vtippyGroupNotification"),
                this.$t("message.vtippyAnnouncemenNotification"),
                this.$t("message.vtippyTicketNotification"),
            ],
        };
    },
    computed: {
        ...mapState({
            user: (state) => _.cloneDeep(state.auth.user),
            site: (state) => state.site.site,
            isAdmin: (state) => state.auth.adminUser != null,
        }),
        lang: {
            get() {
                return _.get(this.user, "lang");
            },
            set(lang) {
                this.updateMe({ _id: this.user._id, lang }).then(() => {
                    this.updateLang(lang);
                    sendSocketMessage("user lang-change", {
                        userId: this.user._id,
                        siteId: this.site._id,
                        lang: lang,
                    });
                });
            },
        },
    },
    methods: {
        ...mapActions({
            getUser: "user/getUser",
            updateMe: "user/updateMe",
            updateUserPassword: "user/updateUserPassword",
            refreshAuthUser: "auth/refreshAuthUser",
        }),
        ...mapMutations({
            updateLang: "auth/UPDATE_LANG",
        }),
        playPreviewSound(settings) {
            log("play sound is here ", settings);
            let path;
            if (!settings.soundFile.includes("male-")) path = `${settings.soundFile}`;
            else path = `${settings.soundFile}${this.$i18n.locale}`;
            let audio = new Audio(`./static/media/ogg_folder/${path}.ogg`);
            audio.volume = settings.audioLevel / 100;
            audio
                .play()
                .then(() => {
                    log("sound played");
                })
                .catch((e) => {
                    log("sound did not play", e);
                    this.$message.error(this.$t("message.chooseAnOption"));
                });
        },
        updateNotificationSettings: _.debounce(async function (notificationSettings) {
            this.user.notificationSettings = notificationSettings;
            await this.updateMe({ ...this.user });
            sendSocketMessage("user user-updated", {
                userId: this.user._id,
                siteId: this.site._id,
            });
            await this.refreshAuthUser();
            await this.$toasted.show(this.$t("message.userVolumeUpdated"), {
                duration: 3000,
                position: "bottom-center",
            });
        }, 500),

        changeUserName() {
            this.$validator.validateAll().then((response) => {
                if (response) {
                    const result = this.updateMe({ ...this.user });
                    result.then(() => {
                        this.$toasted.show(this.$t("message.userSaved"), {
                            duration: 3000,
                            position: "bottom-center",
                        });
                        const socketMessageId = this.isAdmin ? "admin user-updated" : "user user-updated";
                        sendSocketMessage(socketMessageId, {
                            userId: this.user._id,
                            siteId: this.site._id,
                        });
                    });
                }
            });
        },
        changePassword() {
            this.$validator.validateAll().then((response) => {
                if (response) {
                    this.updateUserPassword({
                        id: this.user._id,
                        oldPassword: this.oldPassword,
                        newPassword: this.newPassword,
                    })
                        .then(() => {
                            this.oldPassword = "";
                            this.newPassword = "";
                            this.passwordConfirmation = "";
                            //clear errors when text empty and password change success
                            this.$nextTick(() => {
                                this.errors.clear();
                                this.$nextTick(() => {
                                    this.$validator.reset();
                                });
                            });
                            this.$toasted.show(this.$t("message.passwordChangeSuccess"), {
                                duration: 5000,
                                position: "bottom-center",
                            });
                        })
                        .catch(() => {
                            this.$toasted.show(this.$t("message.oldPasswordError"), {
                                duration: 5000,
                                position: "bottom-center",
                            });
                        });
                }
            });
        },
        beforeUpload(file) {
            const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/jpg" || file.type === "image/png";
            if (!isJpgOrPng) {
                this.$toasted.show("Sadece Resim Yükleyebilirsiniz!", {
                    duration: 3000,
                });
            }
            const isLt2M = file.size / 1024 / 1024 < 20;
            if (!isLt2M) {
                this.$toasted.show("Resminizin Boyutu En Fazla 2MB Olmalıdır!", {
                    duration: 3000,
                });
            }
            return isJpgOrPng && isLt2M;
        },
        async uploadFile(e) {
            let {
                files: [file],
            } = document.getElementById(e.target.id);
            if (!this.beforeUpload(file)) return;
            let path = `${this.site._id}/avatar/${this.user._id}`;
            try {
                let imdUploadData = await uploadAsset({
                    path,
                    mime: file.type,
                    name: file.name,
                    size: file.size,
                    type: "user-avatar",
                });
                this.updateMe({
                    ...this.user,
                    gravatar: imdUploadData.data.asset.v2Format && imdUploadData.data.asset.cdnUrl
                        ? imdUploadData.data.asset.cdnUrl
                        : `https://static.supsis.live/${path + imdUploadData.data.asset._id}`,
                });

                await axios({
                    method: imdUploadData.data.method,
                    url: imdUploadData.data.url,
                    data: file,
                    headers: { "Content-Type": "application/octet-stream" },
                });
                this.$toasted.success(this.$t("message.successImgUpload"), {
                    duration: 1000,
                    position: "bottom-center",
                });
                this.gravatar = imdUploadData.data.asset.v2Format && imdUploadData.data.asset.cdnUrl
                ? imdUploadData.data.asset.cdnUrl
                :`https://static.supsis.live/${path + imdUploadData.data.asset._id}`;
                this.refreshAuthUser();
            } catch (e) {
                this.$toasted.error(this.$t("message.errorImgUpload"), {
                    duration: 1000,
                    position: "bottom-center",
                });
            }
        },
    },
    mounted() {
        if (!!this.user) {
            this.notificationSettings = this.notificationSettings.map((x) => {
                let md = this.user.notificationSettings.find((xx) => xx.type === x.type);
                x["infinitePlay"] = !x.infinitePlay ? false : x.infinitePlay;
                if (!!md) md["infinitePlay"] = !md.infinitePlay ? x.infinitePlay : md.infinitePlay;
                if (!!md) return md;
                return x;
            });
        }
        if (this.isTargetNotification === true) {
            const notificationTab = document.getElementById("notificationSettingsTab");
            notificationTab.click();
        }
    },
    watch: {
        notificationSettings: {
            handler(newValue) {
                if (newValue) {
                    if (this.isFirstOpening) {
                        this.isFirstOpening = false;
                    } else {
                        this.updateNotificationSettings(newValue);
                    }
                }
            },
            deep: true,
        },
        user(newUser) {
            log.debug("newUser", newUser);
            this.volume = newUser.audioAlertVolume ? newUser.audioAlertVolume * 100 : 0;
        },
    },
    beforeDestroy() {
        this.isFirstOpening = true;
    },
};
</script>

<style lang="scss" scoped>
.width-500 {
    width: 100%;
    max-width: 500px;
}

.containerKeyOne {
    width: 100%;
    max-width: 250px;
    margin: 0px auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 20px;

    .md-fieldLabel {
        margin-left: 90px;
    }

    .mDinput {
        display: flex;
        justify-content: center;
        text-align: center;
    }

    .emailAddress {
        padding: 10px;
        display: flex;
        justify-content: center;
    }
}

.containerKeyThree {
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
    padding: 0 20px;
    overflow-x: auto;

    .listItem {
        display: flex;
        flex-direction: column;
        gap: 5px;
    }
}

.containerKeyFour {
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 0 20px;

    keyfour-label {
        font-weight: bold;
    }

    keyfour-select {
        border-radius: 10px;
        width: 100%;
        max-width: 200px;
        height: 40px;
    }
}

.sound-settings-container {
    display: flex;
    flex-direction: column;
    gap: 12px;

    .sound-settings-element {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 8px;
        min-width: 0;
        flex-wrap: nowrap;

        .sound-settings-select {
            width: 140px;
            flex-shrink: 1;
            min-width: 80px;
        }

        .sound-settings-title {
            width: 18%;
            flex-shrink: 1;
            min-width: 80px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 14px;
        }

        input[type="range"] {
            flex: 1;
            min-width: 60px;
            flex-shrink: 1;
        }

        label {
            margin-right: 2px !important;
            width: 45px;
            flex-shrink: 0;
            font-size: 13px;
            text-align: center;
        }

        .play-sound-button {
            margin-right: 2px !important;
            margin-left: 2px !important;
            margin-bottom: 12px !important;
            padding: 2px !important;
            flex-shrink: 0;
            min-width: 36px;
        }

        @media (max-width: 1024px) {
            .sound-settings-title {
                width: 16%;
                min-width: 70px;
                font-size: 13px;
            }
            
            .sound-settings-select {
                width: 120px;
                min-width: 70px;
            }

            label {
                width: 40px;
                font-size: 12px;
            }
        }

        @media (max-width: 768px) {
            gap: 6px;
            
            .sound-settings-title {
                width: 15%;
                min-width: 60px;
                font-size: 12px;
            }
            
            .sound-settings-select {
                width: 100px;
                min-width: 60px;
                font-size: 12px;
            }
            
            input[type="range"] {
                min-width: 50px;
            }
            
            label {
                width: 35px;
                font-size: 11px;
            }

            .play-sound-button {
                min-width: 32px;
                transform: scale(0.9);
            }
        }

        @media (max-width: 480px) {
            gap: 4px;
            
            .sound-settings-title {
                width: 12%;
                min-width: 50px;
                font-size: 11px;
            }
            
            .sound-settings-select {
                width: 80px;
                min-width: 50px;
                font-size: 11px;
            }
            
            input[type="range"] {
                min-width: 40px;
            }
            
            label {
                width: 30px;
                font-size: 10px;
            }

            .play-sound-button {
                min-width: 28px;
                transform: scale(0.85);
            }
        }
    }

    .sound-settings-element > *:not(:last-child) {
        display: block;
        margin-right: 6px;
        margin-bottom: 12px;
    }
}

.desktop-notifications {
    margin-top: 16px;
    background: linear-gradient(135deg, #f8f9ff 0%, #f0f2ff 100%);
    border-radius: 10px;
    padding: 14px;
    box-shadow: 0 1px 6px rgba(93, 91, 141, 0.08);

    &-header {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 12px;
        padding-bottom: 10px;
        border-bottom: 1px solid rgba(93, 91, 141, 0.1);

        svg {
            flex-shrink: 0;
            width: 16px;
            height: 16px;
        }
    }

    &-title {
        margin: 0;
        font-size: 13px;
        font-weight: 600;
        color: #272657;
        letter-spacing: -0.2px;
    }

    &-switches {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
        gap: 8px;

        @media (max-width: 768px) {
            grid-template-columns: 1fr;
        }
    }

    .notification-card {
        background: white;
        border-radius: 8px;
        padding: 10px 12px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        border: 1px solid rgba(93, 91, 141, 0.08);
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
        cursor: pointer;

        &:hover {
            transform: translateY(-1px);
            box-shadow: 0 2px 10px rgba(93, 91, 141, 0.15);
            border-color: rgba(93, 91, 141, 0.2);
        }

        .notification-content {
            display: flex;
            align-items: center;
            gap: 8px;
            flex: 1;
            min-width: 0;
        }

        .notification-icon {
            width: 28px;
            height: 28px;
            border-radius: 6px;
            background: linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 100%);
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
            transition: all 0.3s ease;

            svg {
                width: 14px;
                height: 14px;
            }
        }

        &:hover .notification-icon {
            transform: scale(1.08) rotate(3deg);
            background: linear-gradient(135deg, #e8e8ff 0%, #d0d0ff 100%);
        }

        .notification-label {
            font-size: 12px;
            font-weight: 500;
            color: #272657;
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .notification-switch {
            flex-shrink: 0;
            margin: 0 !important;
            transform: scale(0.85);
        }
    }
}

.notification-warning {
    display: flex;
    align-items: flex-start;
    margin-top: 16px;
    padding: 12px;
    background-color: #f5f5f5;
    border-radius: 8px;

    &-img {
        margin-right: 12px;
        flex-shrink: 0;
        width: 40px;
        height: auto;
    }

    &-text {
        font-family: Poppins, serif;
        font-size: 14px;
        line-height: 1.5;
    }

    @media (max-width: 480px) {
        flex-direction: column;
        align-items: center;
        text-align: center;

        &-img {
            margin-right: 0;
            margin-bottom: 8px;
        }
    }
}

.imgUpload {
    cursor: pointer;
    position: relative;
    width: 84px;
    height: 84px;

    &:hover {
        .imgUploadOver {
            opacity: 1;
        }
    }

    .imgUploadOver {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        z-index: 2;
        background-color: rgba(0, 0, 0, 0.55);
        color: #ffffff;
        font-size: 32px;
        opacity: 0;
        transition: all 0.3s ease-in-out;
        cursor: pointer;
        border-radius: 100%;
        text-align: center;
        line-height: 64px;
    }
}
</style>
